export default __webpack_public_path__ + "media/track-action2x.0a3fad17.png";